import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useGetReceiptImagesWithTenant } from '@pflegenavi/service-provider-frontend/api';
import { useUrlsToImages } from '@pflegenavi/shared-frontend/platform';
import type { UrlTypeNameMapping } from '@pflegenavi/web-components';
import { useFileUrlToTypeMapping } from '@pflegenavi/web-components';
import { EnlargeImageGallery } from '@pflegenavi/transaction-components';

interface ReceiptBatchTableEnlargeGalleryProps {
  selectedBatchTenant: string | undefined;
  openImageGallery: boolean;
  setOpenImageGallery: (open: boolean) => void;
  batchImageIds: string[] | undefined;
  title: string;
  generatedReceiptImageUrls: string[];
  setGeneratedReceiptImageUrls: React.Dispatch<React.SetStateAction<string[]>>;
  generatedReceiptTypeMap: UrlTypeNameMapping;
}

export const ReceiptBatchTableEnlargeGallery: FC<
  ReceiptBatchTableEnlargeGalleryProps
> = ({
  selectedBatchTenant,
  batchImageIds,
  openImageGallery,
  setOpenImageGallery,
  title,
  generatedReceiptImageUrls,
  setGeneratedReceiptImageUrls,
  generatedReceiptTypeMap,
}) => {
  const useReceiptImages = useGetReceiptImagesWithTenant({
    tenant: selectedBatchTenant ?? '',
  });

  const { receiptImages: receiptImageUrls, ImageUrlsLoading } = useUrlsToImages(
    {
      receiptImageIds: batchImageIds,
      useReceiptImages: useReceiptImages,
    }
  );

  const imageUrlToTypeMap = useFileUrlToTypeMapping(receiptImageUrls);

  const handleClose = useCallback(() => {
    setGeneratedReceiptImageUrls([]);
    setOpenImageGallery(false);
  }, [setGeneratedReceiptImageUrls, setOpenImageGallery]);

  return (
    <EnlargeImageGallery
      loading={ImageUrlsLoading}
      open={openImageGallery}
      handleClose={handleClose}
      initialSelectedIndex={0}
      imageUrls={
        generatedReceiptImageUrls.length > 0
          ? generatedReceiptImageUrls
          : receiptImageUrls || []
      }
      imageUrlToTypeMap={
        generatedReceiptImageUrls.length > 0
          ? generatedReceiptTypeMap
          : imageUrlToTypeMap
      }
      title={title}
    />
  );
};
